import { render, staticRenderFns } from "./IcuCareAtHome.vue?vue&type=template&id=b467eb8a&"
import script from "./IcuCareAtHome.vue?vue&type=script&lang=js&"
export * from "./IcuCareAtHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports